import { Col, Row, Space } from 'antd'
import { FC } from 'react'
import { BitazzaText } from '../../../../components'

interface Props {
    img: string
    title: string
    des?: string
    maxDes?: string
    min: string
}
export const Tier: FC<Props> = ({ img, title, des, maxDes, min }) => {
    return (
        <Row>
            <Col span={4}>
                <img src={img} alt="rewards" width={36} />
            </Col>
            <Col span={20}>
                <Space direction="vertical" size={0}>
                    <BitazzaText
                        content={title}
                        color="#FFFFFF"
                        format="t18"
                        letterSpacing={2}
                        bold
                    />

                    {des && (
                        <BitazzaText
                            content={des}
                            color="#86A1A1"
                            lineHeight={20}
                            format="t16"
                            noWrap
                        />
                    )}

                    {maxDes ? (
                        <BitazzaText
                            content={maxDes}
                            color="#EF4150"
                            format="t16"
                            letterSpacing={2}
                            bold
                            noWrap
                        />
                    ) : null}
                    <BitazzaText
                        content={min}
                        color="#86A1A1"
                        lineHeight={20}
                        format="t16"
                        noWrap
                    />
                </Space>
            </Col>
        </Row>
    )
}
